<template>
    <div id="app">

        <router-view></router-view>

    </div>
</template>

<script>
    export default {
        name: 'app',
        methods: {

        }
    }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/views/layouts/App.vue